import React from 'react';
import { PageTitle, ProjectContainer, ProjectItem, JoinUs } from '../components/ui';
import lang from '../assets/lang';

export const Projects = () => {

	const getProjects = () =>
		lang.projects.map(project =>
			<ProjectItem
				key={project.link}
				image={project.image}
				link={project.link} />
		);

	return (
		<div>
			<PageTitle
				title={lang.titleProjects}
				text={lang.textProjects} />

			<ProjectContainer>
				{getProjects()}
			</ProjectContainer>

			<JoinUs
				title={lang.titleJoinUs}
				text={lang.textJoinUs}
				buttonText={lang.buttonTextJoinUs}
				link={lang.buttonLinkJoinUs} />
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/pages/Projects.js